// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"64421d16","828":"e6a4a76c"}[chunkId] + ".chunk.js";
};